import type { Nullable } from '../../types.ts';

/** Session amounts arrive as decimal strings; sums are kept in integer cents to avoid drift. */
export const toCents = (amount: Nullable<string>) =>
  amount ? Math.round(Number(amount) * 100) : 0;

export const centsToDollars = (cents: number) => cents / 100;

export const toPercent = (part: number, whole: number) => (whole ? (part / whole) * 100 : null);
